export const PREDICATIVE = 'PREDICATIVE';
export const CONDITIONAL = 'CONDITIONAL';
